import { datepicker } from "./datepicker"
export const custom = {
    'html, body': {
        color: 'gray.700',
    },    
    a:{
        WebkitTransition: 'all 0.3s ease',
        MozTransition: 'all 0.3s ease',        
        OTransition: 'all 0.3s ease',        
        transition: 'all 0.3s ease',
        textDecoration: "none",
        // "&:hover":{
        //     textDecoration: "underline"
        // }        
    },
    '.dash-nav': {
        cursor: 'pointer',
        py: 2,
        px:2,
        rounded: 'md',
        '&.active': {
            borderColor: 'brand.500',
            backgroundColor: 'rgba(0,0,0,0.25)',
            color: 'white',
            '&:hover': {
                borderColor: 'brand.500',
                // backgroundColor: 'gray.50',
                // color: 'brand.500',
            },
            '&.green':{
                '&.active':{
                    borderColor: 'green.300',                    
                }
            }
        },
        
    },
    ".ql-toolbar":{
        "&.ql-snow":{
            bg: "gray.50",
            borderTopLeftRadius: "sm",
            borderTopRightRadius: "sm"
        }
    },
    ".ql-container.ql-snow":{
        borderBottomLeftRadius: "sm",
        borderBottomRightRadius: "sm",        
    },
    ".ql-toolbar.ql-snow + .ql-container.ql-snow .ql-editor":{        
        minH: '150px',
        maxH: '350px',
        fontSize: "sm",        
    },
    '.hover-reveal':{
            '&:hover':{
                '.hover-target':{
                    display: 'flex'
                }
            }
        },
    '::-webkit-scrollbar':{
            bg: '#f2f2f2',
            w: '4px',
            h: '4px'
        },            
    '::-webkit-scrollbar-thumb': {
            bg: '#C9C9C9',
            borderRadius: '5px'
        },            
    '::-webkit-scrollbar-thumb:hover, ::-webkit-scrollbar-thumb:active':{
            cursor: 'pointer'
    },
    ".sidebar-menu::-webkit-scrollbar":{
        bg: 'transparent',
        w: '6px',
        h: '6px'
    },            
    '.sidebar-menu::-webkit-scrollbar-thumb': {
        bg: 'rgba(0,0,0,0.45)',
        // bg: "red",
        display: 'none',
        borderRadius: '5px',                
    },            
    '.sidebar-menu:hover::-webkit-scrollbar-thumb':{
        display: 'block'
    },
    "table.basic":{
        w: "100%",
        bg: "white",
        rounded: "lg",
        shadow: "sm",
        position: "relative",
        tfoot:{
            position: "sticky",
        },
        thead:{   
            zIndex: 9,
            borderColor: "gray.100",
            position: "sticky",
            top: 0,
            shadow: "custom",       
            borderBottom: "1px solid",
            tr:{
                borderBottom: "1px solid",
                borderColor: "gray.100",
            },
            th:{
                // top: 0,
                bg: "white",
                // position: "sticky",
                textAlign: 'left',
                textTransform: "uppercase",
                fontSize: "0.7rem",                       
                py:3,
                px:3,
                fontWeight: '600',
                color: 'gray.800',   
                "&:first-of-type":{
                    pl: 12
                },             
                borderBottom: "1px solid",
                borderColor: "gray.100",
                "&[data-align='right']":{
                    textAlign: "right"
                },                
            }
        },
        tbody:{
            td:{
                fontSize: "0.9rem",
                py:3,
                px:3,
                color: 'gray.500',
                bg: "transparent",                
                maxW: '35%',
                borderWidth: "1px",
                borderTopWidth: "0",
                borderBottomWidth: "0",
                transition: "all 0.3s ease-in",
                verticalAlign: 'middle',
                "&:first-of-type":{                    
                    pl: 12
                },             
                "&.title":{
                    fontSize: "0.95rem",
                    fontWeight: '500',
                    color: 'accent.500'
                },
                "&[data-align='right']":{
                    textAlign: "right"
                },  
                borderBottom: "1px dashed",
                borderColor: "gray.100",              
            },
            tr:{
                transition: "all 0.3s ease-in",
                "&:hover":{
                    td:{
                        bg: 'gray.50'
                    }
                }
            }

        }
    },    
    ".react-datepicker-wrapper":{
        display: "block",
        w: "100%"
    },
    ".react-datepicker__month .react-datepicker__month-text, .react-datepicker__month .react-datepicker__quarter-text":{
        lineHeight: 'var(--chakra-lineHeights-10)',
        
    },
    ".react-datepicker__month .react-datepicker__month--selected":{
        bg: 'var(--chakra-colors-brand-500)',
        "&:hover":{
            bg: 'var(--chakra-colors-brand-600)',
        }
    },
    ...datepicker
}   
